<template>
    <div class="ball-info switchTarget">
        <!-- <v-touch tag="div" @pinch="invalidPinch($event)" class="ballInfoMain" v-if="mode === 'atBat' && allBalls !== null"> -->
        <div
            v-if="mode === 'atBat' && allBalls !== null"
            class="ballInfoMain"
        >
            <!-- <p>{{ gameDate }}</p> -->
            <div class="pitcher">
                <p class="team">
                    {{ ball.team.name }}
                </p>
                <p class="player">
                    <span class="no">{{ ball.pitcher.uniform_number }}</span><span
                        class="name"
                    >{{ ball.pitcher.name }}</span>
                </p>
            </div>
            <div class="infoWrapper">
                <table class="info">
                    <tr>
                        <td class="item">
                            球場
                        </td>
                        <td class="value">
                            {{
                                ball.data.pitchingdata.Stadium in listOfStadiums ? listOfStadiums[ball.data.pitchingdata.Stadium].additional.name_short : ' - '
                            }}
                        </td>
                    </tr>
                    <tr>
                        <td class="item">
                            対打者
                        </td>
                        <td class="value">
                            <p class="team">
                                {{ ball.vsTeam.name }}
                            </p>
                            <p class="player">
                                {{ ball.batter.name }}
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td class="item">
                            打席
                        </td>
                        <td class="value">
                            第{{ ball.data.pitchingdata.PA !== undefined ? ball.data.pitchingdata.PA : ' - ' }}打席
                        </td>
                    </tr>
                    <tr>
                        <td class="item">
                            球目
                        </td>
                        <td class="value">
                            {{ ball.data.pitchofpa }}球目
                        </td>
                    </tr>
                    <tr>
                        <td class="item">
                            球種
                        </td>
                        <td class="value">
                            {{ setting.typesOfBall[ball.data.pitchingdata.TaggedPitchType].name }}
                        </td>
                    </tr>
                    <tr>
                        <td class="item">
                            球速
                        </td>
                        <td class="value">
                            {{ ball.data.pitchingdata.RelSpeed ? (ball.data.pitchingdata.RelSpeed / 1000).toFixed(1) : ' - ' }}km/h
                        </td>
                    </tr>
                    <tr>
                        <td class="item">
                            回転速度
                        </td>
                        <td class="value">
                            {{ ball.data.pitchingdata.SpinRate ? ball.data.pitchingdata.SpinRate.toFixed(1) : ' - '}}rpm
                        </td>
                    </tr>
                    <tr>
                        <td class="item">
                            α
                        </td>
                        <td class="value">
                            {{ ball.data.pitchingdata.Rifle ? ball.data.pitchingdata.Rifle.toFixed(1) : ' - ' }}°
                        </td>
                    </tr>
                    <tr>
                        <td class="item">
                            カウント
                        </td>
                        <td class="value">
                            {{ ball.data.pitchingdata.Balls }} - {{ ball.data.pitchingdata.Strikes }} - {{
                                ball.data.pitchingdata.Outs
                            }}
                        </td>
                    </tr>
                    <tr>
                        <td class="item">
                            結果
                        </td>
                        <td class="value">
                            {{ getResultText(ball.data.pitchingdata.PitchCall, ball.data.pitchingdata.HitType) }}
                        </td>
                    </tr>
                </table>
            </div>
            <v-touch
                v-if="opened"
                tag="p"
                class="triangle"
                @tap="close"
            >
                <span class="icon-arrow-up" />
            </v-touch>
            <v-touch
                v-else
                tag="p"
                class="triangle"
                @tap="open"
            >
                <span class="icon-arrow-down" />
            </v-touch>
            <!-- </v-touch> -->
        </div>

        <!-- <v-touch tag="div" @pinch="invalidPinch($event)" class="ballInfoMain" v-else-if="mode === 'compare'"> -->
        <div
            v-else-if="mode === 'compare'"
            class="ballInfoMain compare-Info"
        >
            <!-- <p>{{ gameDate }}</p> -->
            <div
                v-if="comparativeStandardBall.length > 0 && comparativeStandardBall[0]"
                class="pitcher"
            >
                <p class="team">
                    {{ comparativeStandardBall[0].team.name }}
                </p>
                <p class="player">
                    <span class="no">{{ comparativeStandardBall[0].pitcher.uniform_number }}</span><span
                        class="name"
                    >{{ comparativeStandardBall[0].pitcher.name }}</span>
                </p>
            </div>
            <div
                v-else
                class="attention"
            >
            <v-touch
                tag="p"
                class="openSearchBtn compare-Btn"
                @tap="openSearchModal('standard')"
            >
                <p class="text ball-add-text">
                    基準球を追加してください
                </p>
                    <span class="icon-search" />
                </v-touch>
            </div>
            <div
                v-if="comparativeStandardBall.length > 0 && comparativeStandardBall[0]"
                class="infoWrapper"
            >
                <table class="info">
                    <tr>
                        <td class="item">
                            球目
                        </td>
                        <td class="value">
                            {{ comparativeStandardBall[0].data.pitchofpa }}球目
                        </td>
                    </tr>
                    <tr>
                        <td class="item">
                            球種
                        </td>
                        <td class="value">
                            {{ setting.typesOfBall[comparativeStandardBall[0].data.pitchingdata.TaggedPitchType].name }}
                        </td>
                    </tr>
                    <tr>
                        <td class="item">
                            球速
                        </td>
                        <td class="value">
                            {{ (comparativeStandardBall[0].data.pitchingdata.RelSpeed / 1000).toFixed(1) }}km/h
                        </td>
                    </tr>
                    <tr>
                        <td class="item">
                            回転速度
                        </td>
                        <td class="value">
                            {{
                                comparativeStandardBall[0].data.pitchingdata.SpinRate.toFixed(1)
                            }}rpm
                        </td>
                    </tr>
                    <tr>
                        <td class="item">
                            α
                        </td>
                        <td class="value">
                            {{
                                comparativeStandardBall[0].data.pitchingdata.Rifle.toFixed(1)
                            }}°
                        </td>
                    </tr>
                    <tr>
                        <td class="item">
                            結果
                        </td>
                        <td class="value">
                            {{
                                getResultText(comparativeStandardBall[0].data.pitchingdata.PitchCall,
                                              comparativeStandardBall[0].data.pitchingdata.HitType)
                            }}
                        </td>
                    </tr>
                </table>
            </div>
            <div class="icon-area">
                <v-touch
                    v-if="comparativeStandardBall.length > 0 && comparativeStandardBall[0]"
                    tag="p"
                    class="openSearchBtn icon-feature"
                    @tap="openSearchModal('standard')"
                >
                    <span class="icon-search icon-feature-span" />
                </v-touch>
                <v-touch
                    v-if="(comparativeStandardBall.length > 0 && comparativeStandardBall[0]) && comparativeStandardBall[0]"
                    tag="p"
                    class="dustBox icon-feature"
                    @tap="removeSavedStandardBall()"
                >
                    <span class="icon-delete icon-feature-span" />
                </v-touch>
                <svg
                    v-if="comparativeStandardBall.length > 0 && comparativeStandardBall[0]"
                    class="ballColor"
                    style="position: unset;"
                >
                    <circle
                        cx="10"
                        cy="11"
                        r="6"
                        :fill="comparativeStandardBall[0].ballColor"
                    />
                </svg>
                <v-touch
                    v-if="(comparativeStandardBall.length > 0 && comparativeStandardBall[0]) && comparativeStandardBall[0].enabled === true"
                    tag="p"
                    class="view enable icon-feature"
                    @tap="toggleSavedStandardBall(false)"
                >
                    <span class="icon-view icon-feature-span" />
                </v-touch>
                <v-touch
                    v-else-if="(comparativeStandardBall.length > 0 && comparativeStandardBall[0]) && comparativeStandardBall[0].enabled === false"
                    tag="p"
                    class="view disable icon-feature"
                    @tap="toggleSavedStandardBall(true)"
                >
                    <span class="icon-view icon-feature-span" />
                </v-touch>
                <v-touch
                    v-if="opened === true && comparativeStandardBall.length > 0 && comparativeStandardBall[0]"
                    tag="p"
                    class="triangle icon-feature"
                    @tap="close"
                >
                    <span
                        class="icon-arrow-up icon-feature-span"
                    />
                </v-touch>
                <v-touch
                    v-else-if="opened === false && comparativeStandardBall.length > 0 && comparativeStandardBall[0]"
                    tag="p"
                    class="triangle icon-feature"
                    @tap="open"
                >
                    <span
                        class="icon-arrow-down icon-feature-span"
                    />
                </v-touch>
                <!-- </v-touch> -->
            </div>
        </div>


        <v-touch
            v-if="mode === 'compare' && comparativeStandardBall.length > 0 && comparativeStandardBall[0] "
            tag="div"
            class="addBase"
            @pinch.prevent
        />
        <div class="addButton">
            <v-touch
                v-if="mode === 'atBat' && allBalls !== null"
                tag="div"
                class="addCompare"
                @pinch.prevent
            >
                <v-touch
                    tag="p"
                    class="compareText"
                    @tap="addSavedBalls"
                >
                    <span
                        class="icon-check"
                    /><span>比較モードに追加</span>
                </v-touch>
            </v-touch>
        </div>
    </div>
</template>

<script>
import Common3dBallInfo from '@/components_common/3d/BallInfo.vue'
import {mapGetters} from "vuex"

export default {
    name: 'BallInfo',
    mixins: [Common3dBallInfo],
    computed: {
        ...mapGetters(['listOfStadiums']),
    }
}
</script>

<style scoped>
.ball-info {
    position: absolute;
    top: 55px;
    right: 84px;
}

.ball-finfo-compar {
    position: absolute;
    top: 55px;
}

.ballInfoMain {
    color: #fff;
    width: 250px !important;
    background: rgba(51, 51, 51, 0.95);
    padding-bottom: 30px;
    position: relative;
}

.attention {
    padding: 0 15px;
    padding-top: 8px;
    font-size: 15px;
    line-height: 15px;
    display: flex;
}

.pitcher {
    padding: 15px 10px 15px;
    font-size: 15px;
    line-height: 15px;
}

.pitcher .player {
    margin: 15px 0 0;
}

.pitcher .player .no {
    margin-right: 10px;
}

.info {
    margin: 0 0 5px;
    font-size: 11px;
    border-collapse: separate;
    border-spacing: 10px;
    width: 100%;
}

.info p {
    font-size: 12px;
    line-height: 12px;
    letter-spacing: -0.5px;
}

.info p.team {
    transform: scale(0.8, 1);
    transform-origin: left center;
    width: 125%;
}

.info .item {
    width: 20%;
}

.info .value {
    width: 80%;
}

.info .player {
    margin-top: 6px;
}

.triangle {
    position: absolute;
    width: 20px;
    height: 20px;
    right: 0;
    bottom: 0;
    padding: 10px;
    text-align: center;
    line-height: 20px;
    font-size: 20px;
    color: #bbb;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

/*ピッチトンネルモード基準球として登録*/
.addBase {
    width: 250px;
    background: rgba(68, 68, 68, 0.85);
    color: #fff;
    position: absolute;
    right: 0px;
    margin-top: 10px;
}

.baseText {
    height: 100%;
    font-size: 12px;
    line-height: 27px;
    text-align: center;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

/* ピッチトンネルモード基準球として登録 atBatモード */
.addBaseByBat {
    width: 250px;
    background: rgba(68, 68, 68, 0.85);
    color: #fff;
    position: absolute;
    right: 0px;
    margin-top: 50px;
}

/* 比較モードに追加 */
.addCompare {
    width: 150px;
    background: rgba(68, 68, 68, 0.85);
    color: #fff;
    position: absolute;
    right: 0px;
    margin-top: 10px;
}

.compareText {
    height: 30px;
    font-size: 12px;
    line-height: 27px;
    text-align: center;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.compareText .icon-check {
    font-size: 20px;
    position: relative;
    bottom: 2px;
    padding-right: 5px;
}

.compareText span {
    vertical-align: middle;
}

.infoWrapper {
    transition: .3s;
}

.ballColor {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 90px;
    bottom: 10px;
}

/* 基準球検索 */
.openSearchBtn {
    width: 25px;
    height: 25px;
    position: absolute;
    bottom: 8px;
    left: 2px;
    cursor: pointer;
}
.openSearchBtn .icon-search {
    font-size: 25px;
    padding: 10px;
}

.attention .openSearchBtn {
    left: inherit;
    bottom: 26px;
    right: 20px;
}

.ballInfoMain .dustBox {
    width: 25px;
    height: 25px;
    position: absolute;
    bottom: 8px;
    left: 45px;
    cursor: pointer;
}

.ballInfoMain .dustBox .icon-delete {
    font-size: 25px;
    padding: 10px;
}

/* 表示切替 */
.view {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 40px;
    bottom: 0;
    padding: 10px;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.view.enable .icon-view {
    font-size: 20px;
    color: rgba(255, 255, 255, 1);
}

.view.disable .icon-view {
    font-size: 20px;
    color: rgba(255, 255, 255, 0.35);
}

/* 打者位置・打者目線 */
.batterController {
    position: relative;
    color: #fff;
    width: 250px;
    background: rgba(51, 51, 51, 0.95);
    padding-bottom: 15px;
    margin-top: 10px;
}

.batterPosition {
    padding: 10px 15px 0;
    font-size: 13px;
    line-height: 13px;
}

.batterPosition tr td {
    width: 60px;
    height: 20px;
    font-size: 13px;
    text-align: left;
    vertical-align: middle;
    cursor: pointer;
}

.batterPosition tr td:nth-child(2) {
    width: 110px;
    height: 20px;
    background-color: rgba(34, 34, 34, 0.75);
    font-size: 11px;
    text-align: center;
}

.boxWrapper {
    width: 220px;
    padding-top: 10px;
    margin: 0 auto;
}

.batterBox {
    width: 125px;
    height: 118px;
    padding-top: 23px;
    display: inline-block;
    overflow: hidden;
}

.batterBox svg {
    width: 48px;
    height: 72px;
    float: left;
}

.batterBox svg:nth-child(2) {
    width: 29px;
    height: 72px;
}

.batterBox svg path {
    fill: #ffffff;
    stroke-width: 0;
    stroke: none;
}

.boxController {
    width: 82px;
    height: 118px;
    display: inline-block;
    margin-left: 10px;
    padding-top: 1px;
}

.boxController table {
    width: 82px;
    height: 16px;
    margin-bottom: 9px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
}

.boxController table:nth-child(3) {
    margin-bottom: 0;
}

.boxController table tr {
}

.boxController table tr td {
    width: 50%;
    height: 32px;
    border: 1px solid #ffffff;
    font-size: 1rem;
    cursor: pointer;
    text-align: center;
    vertical-align: middle;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
}

.boxController table tr td:nth-child(2) {
    border-left: 0;
}

.batterPoint {
    padding: 15px 15px 0;
    font-size: 13px;
    line-height: 13px;
}

.batterPoint tr td {
    width: 60px;
    height: 20px;
    font-size: 13px;
    text-align: left;
    vertical-align: middle;
}

.batterPoint tr td:nth-child(2) {
    width: 110px;
    height: 20px;
    background-color: rgba(34, 34, 34, 0.75);
    font-size: 11px;
    text-align: center;
}

/* 打者位置設定パネル */
.batterInputWrapper {
    width: 250px;
    padding: 10px 15px 0;
    font-size: 13px;
    height: 204px;
}

.batterInputWrapper p {
    padding-top: 2px;
    font-size: 13px;
    line-height: 13px;
}

.batterInputWrapper table.batterInputInner {
    width: 220px;
    margin: 34.5px auto;
}

.batterInputWrapper table.batterInputInner tr {
    width: 100%;
    height: 24px;
    box-sizing: border-box;
}

.batterInputWrapper table.batterInputInner tr td {
    width: 110px;
    height: 24px;
    box-sizing: border-box;
    padding-bottom: 30px;
}

.batterInputWrapper table.batterInputInner tr td:nth-child(1),
.batterInputWrapper table.batterInputInner tr td:nth-child(2) {
    width: 55px;
}

.batterInputWrapper table.batterInputInner tr td input[type="number"] {
    -webkit-appearance: none;
}

.batterInputWrapper table.batterInputInner tr td input[type="radio"] {
    display: none;
}

.batterInputWrapper table.batterInputInner tr td input[type="number"] {
    width: 80px;
    height: 24px;
    outline: none;
    border: none;
    background: rgba(34, 34, 34, 0.75);
    color: #ffffff;
    text-align: center;
    line-height: 13px;
    float: left;
    font-size: 11px;
}

.batterInputWrapper table.batterInputInner tr td .unit {
    padding-top: 4px;
    padding-left: 10px;
    float: left;
}

.batterInputWrapper table.batterInputInner tr:nth-child(2) td {
    padding-bottom: 0;
}

.batterInputWrapper table.batterInputInner tr td svg {
    width: 55px;
    height: 24px;
    box-sizing: border-box;
}

.batterInputWrapper table.batterSubmitButton {
    width: 220px;
    margin: 0 auto 10px;
}

.batterInputWrapper table.batterSubmitButton tr td {
    width: 66px;
    text-align: center;
    padding: 0 5px;
}

.batterInputWrapper table.batterSubmitButton tr td:nth-child(1) {
    padding-left: 0;
}

.batterInputWrapper table.batterSubmitButton tr td:nth-child(3) {
    padding-right: 0;
}

.batterInputWrapper table.batterSubmitButton tr td span {
    width: 66px;
    height: 24px;
    display: inline-block;
    font-size: 11px;
    padding-top: 5px;
    border: 1px solid #ffffff;
    box-sizing: border-box;
}

/* 打者目線設定パネル */
.batterInputWrapper.point table.batterInputInner {
    margin: 62px auto;
}

.batterInputWrapper.point table.batterInputInner tr td {
    box-sizing: border-box;
    padding-bottom: 0;
}

.batterInputWrapper.point table.batterInputInner tr td input[type="number"] {
    margin-left: 54px;
}

/* 投手位置・投手目線 */
.pitcherController {
    position: relative;
    color: #fff;
    width: 250px;
    background: rgba(51, 51, 51, 0.95);
    padding-bottom: 15px;
    margin-top: 10px;
}

.pitcherPosition {
    padding: 10px 15px 0;
    font-size: 13px;
    line-height: 13px;
}

.pitcherPosition table {
}

.pitcherPosition tr td {
    width: 60px;
    height: 20px;
    font-size: 13px;
    text-align: left;
    vertical-align: middle;
}

.pitcherPosition tr td:nth-child(2) {
    width: 110px;
    height: 20px;
    background-color: rgba(34, 34, 34, 0.75);
    font-size: 11px;
    text-align: center;
}

.positionBar {
    padding: 15px 0 10px;
}

.pitcherPoint {
    padding: 15px 15px 0;
    font-size: 13px;
    line-height: 13px;
}

.pitcherPoint table {

}

.pitcherPoint tr td {
    width: 60px;
    height: 20px;
    font-size: 13px;
    text-align: left;
    vertical-align: middle;
}

.pitcherPoint tr td:nth-child(2) {
    width: 110px;
    height: 20px;
    background-color: rgba(34, 34, 34, 0.75);
    font-size: 11px;
    text-align: center;
}

.pointBar {
    padding: 15px 0 0;
}

/* 投手位置設定パネル */
.pitcherInputWrapper {
    width: 250px;
    padding: 10px 15px 0;
    font-size: 13px;
    height: 204px;
}

.pitcherInputWrapper p {
    padding-top: 2px;
    font-size: 13px;
    line-height: 13px;
}

.pitcherInputWrapper table.pitcherInputInner {
    width: 220px;
    margin: 62px auto;
}

.pitcherInputWrapper table.pitcherInputInner tr {
    width: 100%;
    height: 24px;
    box-sizing: border-box;
}

.pitcherInputWrapper table.pitcherInputInner tr td {
    width: 110px;
    height: 24px;
    box-sizing: border-box;
    padding-bottom: 0;
}

.pitcherInputWrapper table.pitcherInputInner tr td:nth-child(1),
.pitcherInputWrapper table.pitcherInputInner tr td:nth-child(2) {
    width: 55px;
}

.pitcherInputWrapper table.pitcherInputInner tr td input[type="number"] {
    -webkit-appearance: none;
}

.pitcherInputWrapper table.pitcherInputInner tr td input[type="radio"] {
    display: none;
}

.pitcherInputWrapper table.pitcherInputInner tr td input[type="number"] {
    width: 80px;
    height: 24px;
    outline: none;
    border: none;
    background: rgba(34, 34, 34, 0.75);
    color: #ffffff;
    text-align: center;
    line-height: 13px;
    float: left;
    font-size: 11px;
}

.pitcherInputWrapper table.pitcherInputInner tr td .unit {
    padding-top: 4px;
    padding-left: 10px;
    float: left;
}

.pitcherInputWrapper table.pitcherInputInner tr:nth-child(2) td {
    padding-bottom: 0;
}

.pitcherInputWrapper table.pitcherInputInner tr td svg {
    width: 55px;
    height: 24px;
    box-sizing: border-box;
}

.pitcherInputWrapper table.pitcherSubmitButton {
    width: 220px;
    margin: 0 auto 10px;
}

.pitcherInputWrapper table.pitcherSubmitButton tr td {
    width: 66px;
    text-align: center;
    padding: 0 5px;
}

.pitcherInputWrapper table.pitcherSubmitButton tr td:nth-child(1) {
    padding-left: 0;
}

.pitcherInputWrapper table.pitcherSubmitButton tr td:nth-child(3) {
    padding-right: 0;
}

.pitcherInputWrapper table.pitcherSubmitButton tr td span {
    width: 66px;
    height: 24px;
    display: inline-block;
    font-size: 11px;
    padding-top: 5px;
    border: 1px solid #ffffff;
    box-sizing: border-box;
}

/* 投手目線設定パネル */
.pitcherInputWrapper.point table.pitcherInputInner {
    margin: 62px auto;
}

.pitcherInputWrapper.point table.pitcherInputInner tr td {
    box-sizing: border-box;
    padding-bottom: 0;
}

.pitcherInputWrapper.point table.pitcherInputInner tr td input[type="number"] {
    margin-left: 54px;
}

/* slider */
[type="range"] {
    display: block;
    position: relative;
    width: 220px;
    margin: 0 auto;
    height: 1px;
    background-color: rgba(255, 255, 255, 1);
    z-index: 1;
}

[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    position: relative;
    z-index: 15;
    width: 12px;
    height: 12px;
    background-color: rgba(255, 255, 255, 1);
    -webkit-border-radius: 100%;
    -moz-border-radius: 100%;
    border-radius: 100%;
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

[type="range"]:focus,
[type="range"]:focus::-webkit-slider-thumb,
[type="range"]:active,
[type="range"]:active::-webkit-slider-thumb {
    outline: none;
}

[type="range"]:active::-webkit-slider-thumb {
    background-color: rgba(255, 20, 147, 1.0);
}

/* slider label */
.rangeLabel {
    width: 220px;
    margin: 10px auto 0;
}

.rangeLabel tr td:nth-child(1) {
    text-align: left;
}

.rangeLabel tr td:nth-child(2) {
    text-align: center;
}

.rangeLabel tr td:nth-child(3) {
    text-align: right;
}

.close {
    width: 25px;
    height: 25px;
    position: absolute;
    color: #fff;
    line-height: 25px;
    font-size: 20px;
    top: 8px;
    right: 10px;
    cursor: pointer;
}

.disabledBtn {
    opacity: 0.65;
}

.disable {
    opacity: 0.5;
}
.ball-add-text {
    display: flex;
    align-items: center;
}
.compare-Info {
    width: unset;
    padding-bottom: unset;
}
.compare-Btn {
    width: auto;
    height: auto;
    display: flex;
    position: unset;
}
.icon-area {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
}
.ballInfoMain .icon-feature {
    width: unset;
    height: unset;
    position: unset;
    padding: unset;
}
.ballInfoMain .dustBox .icon-feature-span {
    padding: 5px;
}
.ballInfoMain .icon-feature-span {
    padding: 5px;
}
</style>
